import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import logoEng from '../../assets/images/webLogo/gnas-logo-eng.png'
import logoGeo from '../../assets/images/webLogo/lastlogogeo-01.png'

const WebLogoEng = () => {
  return <img className='w-full object-contain' src={logoEng} alt='logo-eng' />
}

const WebLogoGeo = () => {
  return <img className='w-full h-full object-contain' src={logoGeo} alt='logo-eng' />
}

const WebLogo = () => {
  const { t } = useTranslation()
  return (
    <div className='web-logo'>
      <Link to='/'>
        {`${t('webLogo.imageclass')}` === 'web-logo-eng' ? <WebLogoEng /> : <WebLogoGeo />}
      </Link>
    </div>
  )
}

export default WebLogo
